import store from '../../store/store'

const lang = { lang: 'en' }

const t = (text) => {
  const newState = store.getState()
  const { translations, language } = newState.users

  return translations[text] && translations[text][language] ? translations[text][language] : text
}

export default function Translate(props) {
  const { children } = props

  return t(children)
}

const TranslateDynamic = (props) => {
  const { children } = props
  const arr = [
    { from: '<T1>', to: '</T1>', variable: 't1' },
    { from: '<T2>', to: '</T2>', variable: 't2' },
    { from: '<T3>', to: '</T3>', variable: 't3' },
    { from: '<T4>', to: '</T4>', variable: 't4' },
    { from: '<T5>', to: '</T5>', variable: 't5' }
  ]

  const getDynamicText = (text) => {
    const obj = {}
    let newText = text

    arr.forEach((v) => {
      let startPosition = newText.search(v.from)

      if (startPosition >= 0) {
        startPosition += 4
      }

      const endPosition = newText.search(v.to)

      if (startPosition > 0 && endPosition > 0) {
        const value = newText.slice(startPosition, endPosition)
        obj[v.variable] = { label: `${v.from}${v.to}`, value }
        newText = newText.replace(`${v.from}${value}${v.to}`, `${v.from}${v.to}`)
      }
    })

    return { newText, obj }
  }

  const renderText = (txt) => {
    const { newText, obj = {} } = getDynamicText(txt)
    let translatedText = t(newText)
    Object.values(obj).forEach((v) => {
      translatedText = translatedText.replace(v.label, v.value)
    })

    return translatedText
  }

  return renderText(children)
}

export { TranslateDynamic, lang, t }
